import { defineSemanticTokens, defineTokens } from '@pandacss/dev'

const tokens = defineTokens.colors({
  light: {
    '1': { value: '#fffcfd' },
    '2': { value: '#fff7f8' },
    '3': { value: '#feeaed' },
    '4': { value: '#ffdce1' },
    '5': { value: '#ffced6' },
    '6': { value: '#f8bfc8' },
    '7': { value: '#efacb8' },
    '8': { value: '#e592a3' },
    '9': { value: '#e54666' },
    '10': { value: '#dc3b5d' },
    '11': { value: '#ca244d' },
    '12': { value: '#64172b' },
    a1: { value: '#ff005503' },
    a2: { value: '#ff002008' },
    a3: { value: '#f3002515' },
    a4: { value: '#ff002523' },
    a5: { value: '#ff002a31' },
    a6: { value: '#e4002440' },
    a7: { value: '#ce002553' },
    a8: { value: '#c300286d' },
    a9: { value: '#db002cb9' },
    a10: { value: '#d2002cc4' },
    a11: { value: '#c10030db' },
    a12: { value: '#550016e8' },
  },
  dark: {
    '1': { value: '#191113' },
    '2': { value: '#1e1517' },
    '3': { value: '#3a141e' },
    '4': { value: '#4e1325' },
    '5': { value: '#5e1a2e' },
    '6': { value: '#6f2539' },
    '7': { value: '#883447' },
    '8': { value: '#b3445a' },
    '9': { value: '#e54666' },
    '10': { value: '#ec5a72' },
    '11': { value: '#ff949d' },
    '12': { value: '#fed2e1' },
    a1: { value: '#f4124a09' },
    a2: { value: '#fe5a7f0e' },
    a3: { value: '#ff235d2c' },
    a4: { value: '#fd195e42' },
    a5: { value: '#fe2d6b53' },
    a6: { value: '#ff447665' },
    a7: { value: '#ff577d80' },
    a8: { value: '#ff5c7cae' },
    a9: { value: '#fe4c70e4' },
    a10: { value: '#ff617beb' },
    a11: { value: '#ff949d' },
    a12: { value: '#ffd3e2fe' },
  },
})
const semanticTokens = defineSemanticTokens.colors({
  '1': { value: { _light: '{colors.ruby.light.1}', _dark: '{colors.ruby.dark.1}' } },
  '2': { value: { _light: '{colors.ruby.light.2}', _dark: '{colors.ruby.dark.2}' } },
  '3': { value: { _light: '{colors.ruby.light.3}', _dark: '{colors.ruby.dark.3}' } },
  '4': { value: { _light: '{colors.ruby.light.4}', _dark: '{colors.ruby.dark.4}' } },
  '5': { value: { _light: '{colors.ruby.light.5}', _dark: '{colors.ruby.dark.5}' } },
  '6': { value: { _light: '{colors.ruby.light.6}', _dark: '{colors.ruby.dark.6}' } },
  '7': { value: { _light: '{colors.ruby.light.7}', _dark: '{colors.ruby.dark.7}' } },
  '8': { value: { _light: '{colors.ruby.light.8}', _dark: '{colors.ruby.dark.8}' } },
  '9': { value: { _light: '{colors.ruby.light.9}', _dark: '{colors.ruby.dark.9}' } },
  '10': { value: { _light: '{colors.ruby.light.10}', _dark: '{colors.ruby.dark.10}' } },
  '11': { value: { _light: '{colors.ruby.light.11}', _dark: '{colors.ruby.dark.11}' } },
  '12': { value: { _light: '{colors.ruby.light.12}', _dark: '{colors.ruby.dark.12}' } },
  a1: { value: { _light: '{colors.ruby.light.a1}', _dark: '{colors.ruby.dark.a1}' } },
  a2: { value: { _light: '{colors.ruby.light.a2}', _dark: '{colors.ruby.dark.a2}' } },
  a3: { value: { _light: '{colors.ruby.light.a3}', _dark: '{colors.ruby.dark.a3}' } },
  a4: { value: { _light: '{colors.ruby.light.a4}', _dark: '{colors.ruby.dark.a4}' } },
  a5: { value: { _light: '{colors.ruby.light.a5}', _dark: '{colors.ruby.dark.a5}' } },
  a6: { value: { _light: '{colors.ruby.light.a6}', _dark: '{colors.ruby.dark.a6}' } },
  a7: { value: { _light: '{colors.ruby.light.a7}', _dark: '{colors.ruby.dark.a7}' } },
  a8: { value: { _light: '{colors.ruby.light.a8}', _dark: '{colors.ruby.dark.a8}' } },
  a9: { value: { _light: '{colors.ruby.light.a9}', _dark: '{colors.ruby.dark.a9}' } },
  a10: { value: { _light: '{colors.ruby.light.a10}', _dark: '{colors.ruby.dark.a10}' } },
  a11: { value: { _light: '{colors.ruby.light.a11}', _dark: '{colors.ruby.dark.a11}' } },
  a12: { value: { _light: '{colors.ruby.light.a12}', _dark: '{colors.ruby.dark.a12}' } },
  default: { value: { _light: '{colors.ruby.light.9}', _dark: '{colors.ruby.dark.9}' } },
  emphasized: { value: { _light: '{colors.ruby.light.10}', _dark: '{colors.ruby.dark.10}' } },
  fg: { value: { _light: 'white', _dark: 'white' } },
  text: { value: { _light: '{colors.ruby.light.a11}', _dark: '{colors.ruby.dark.a11}' } },
})

export default {
  name: 'ruby',
  tokens,
  semanticTokens,
}
